/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Threshold_LabelInputs */

const he_notifications_threshold_label = /** @type {(inputs: Notifications_Threshold_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר יעד`)
};

const en_notifications_threshold_label = /** @type {(inputs: Notifications_Threshold_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Price`)
};

/**
* | output |
* | --- |
* | "Target Price" |
*
* @param {Notifications_Threshold_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_threshold_label = /** @type {((inputs?: Notifications_Threshold_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Threshold_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_threshold_label(inputs)
	return en_notifications_threshold_label(inputs)
});